<template>
  <aside class="main-sidebar">
    <!-- sidebar: style can be found in sidebar.less -->
    <section class="sidebar">
      <!-- Sidebar user panel (optional) -->
      <div class="user-panel" style="display:none;">
        <div class="pull-left image">
          <img :src="pictureUrl">
        </div>
        <div class="pull-left info">
          <div>
            <p class="white">{{ displayName }}</p>
          </div>
          <a href="javascript:;">
            <i class="fa fa-circle text-success"></i> Online
          </a>
        </div>
      </div>

      <!-- search form (Optional) -->
      <form v-on:submit.prevent class="sidebar-form" style="display:none;">
        <div class="input-group">
          <input
            type="text"
            name="search"
            id="search"
            class="search form-control"
            data-toggle="hideseek"
            p
            laceholder="Search Menus"
            data-list=".sidebar-menu"
          >
          <span class="input-group-btn">
            <button type="submit" name="search" id="search-btn" class="btn btn-flat">
              <i class="fa fa-search"></i>
            </button>
          </span>
        </div>
      </form>
      <!-- /.search form -->
      <!-- Sidebar Menu -->
      <sidebar-menu/>

      <!-- /.sidebar-menu -->
    </section>
    <!-- /.sidebar -->
    <a href="javascript:;" class="sidebar-toggle" data-toggle="offcanvas" role="button">
      <i class="fa fa-chevron-circle-left"></i>
      <span class="sr-only">Toggle navigation</span>
    </a>
  </aside>
</template>
<script>
import SidebarMenu from './SidebarMenu'

export default {
  name: 'Sidebar',
  props: ['displayName', 'pictureUrl'],
  components: { SidebarMenu }
}
</script>
<style>
.skin-blue .sidebar-menu > li.router-link-exact-active > a {
  color: #fff;
  background: #0e8eae;
  border-left-color: #9fc54c;
}

/* .skin-blue .sidebar-menu > li.router-link-active > a {
  color: #fff;
  background: #0e8eae;
  border-left-color: #9fc54c;
} */

aside.main-sidebar {
  position: fixed;
}
header.main-header {
  position: fixed;
  width: 100vw;
}
section.sidebar {
  height: 89vh;
  position: relative;
  overflow: hidden;
}
.user-panel .image img {
  border-radius: 50%;
}
.main-sidebar .sidebar-toggle {
  display: inline-block;
  position: absolute;
  bottom: 0px;
  font-size: 25px;
  color: #fff;
  right: 10px;
  transition: transform 0.3s ease-in-out, width 1s ease-in-out;
}
.sidebar-collapse .main-sidebar .sidebar-toggle {
  transition: transform 0.5s ease-in-out, width 0.5s ease-in-out;
  left: auto;
  right: auto;
  margin-left: 11px;
}
</style>



// WEBPACK FOOTER //
// Sidebar.vue?57e0013f